import GroupIcon from "@mui/icons-material/Group";
import Tooltip from "@mui/material/Tooltip";
import SuiAvatar from "components/SuiAvatar";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import { useState } from "react";
import toast from "react-hot-toast";
import api from "services/api";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const CommentInput = ({
  userObj,
  subjectid,
  parentReload,
  notifyFunc,
  parent_comment_id = "",
  oldComment = null,
  prefix_content = "",
  size = "md",
  allowCancel = true,
}) => {
  const [message, setMessage] = useState(oldComment ? oldComment.content : prefix_content);
  const cancelInput = () => {
    setMessage("");
    parentReload(false);
  };

  const addComment = () => {
    var commentobj = {
      content: message,
      subjectid: subjectid,
      parent_comment_id: parent_comment_id,
    };
    try {
      if (oldComment) {
        commentobj.id = oldComment.id;
        api.comment.update(commentobj).then(({ data }) => {
          parentReload(true);
          return data;
        });
      } else {
        api.comment.create(commentobj).then(({ data }) => {
          parentReload(true);
          return data;
        });
        setMessage("");
      }
      if (notifyFunc) notifyFunc(message);
    } catch (err) {
      toast.error(`comment create failed!`);
      console.log(err);
    }
  };

  return (
    <SuiBox sx={{ my: 1 }}>
      <SuiBox
        display="flex"
        alignItems="top"
        sx={{ justifyContent: "justify-between", width: "100%" }}
      >
        <Tooltip title={userObj?.username} placement="top-start">
          {userObj.avatar != "" ? (
            <SuiAvatar
              src={userObj.avatar}
              alt="profile-image"
              variant="rounded"
              size="sm"
              shadow="sm"
              sx={{ mr: 1, mt: 0.3 }}
              bgColor="info"
            />
          ) : (
            <SuiAvatar
              alt="profile-image"
              variant="rounded"
              size="sm"
              shadow="sm"
              sx={{ mr: 1, mt: 0.3 }}
              bgColor="info"
            >
              <GroupIcon fontSize="medium" />
            </SuiAvatar>
          )}
        </Tooltip>
        <SuiBox display="flex" alignItems="center" sx={{ width: "100%" }}>
          <SuiInput
            autoFocus={oldComment || parent_comment_id != ""}
            multiline
            maxRows={5}
            sx={{ ml: 1 }}
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            onFocus={(e) =>
              e.currentTarget.setSelectionRange(
                e.currentTarget.value.length,
                e.currentTarget.value.length
              )
            }
          />
          {allowCancel ? (
            size == "sm" ? (
              oldComment || parent_comment_id ? (
                <SuiBox sx={{ mx: 1 }}>
                  <CloseIcon
                    color="error"
                    fontSize="medium"
                    sx={{ cursor: "pointer" }}
                    onClick={cancelInput}
                  />
                </SuiBox>
              ) : (
                <SuiButton
                  sx={{ ml: 1, height: "fit-content", fontSize: 12, px: oldComment ? 0 : 2 }}
                  variant={oldComment ? "text" : "gradient"}
                  color="secondary"
                  onClick={cancelInput}
                >
                  Cancel
                </SuiButton>
              )
            ) : (
              <SuiButton
                sx={{ ml: 1, height: "fit-content" }}
                variant="gradient"
                color="secondary"
                onClick={cancelInput}
              >
                Cancel
              </SuiButton>
            )
          ) : null}
          {size == "sm" ? (
            oldComment || parent_comment_id ? (
              <SuiBox
                sx={{
                  mr: 2,
                  ml: 1,
                }}
              >
                <CheckIcon
                  color="success"
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                  onClick={addComment}
                />
              </SuiBox>
            ) : (
              <SuiButton
                sx={{ ml: 1, height: "fit-content", px: 2, fontSize: 12 }}
                disabled={message.length == 0}
                variant={"gradient"}
                color="info"
                onClick={addComment}
              >
                Comment
              </SuiButton>
            )
          ) : (
            <SuiButton
              sx={{ ml: 1, height: "fit-content", px: oldComment ? 4.7 : null }}
              disabled={message.length == 0}
              variant="gradient"
              color="info"
              onClick={addComment}
            >
              {oldComment ? "Update" : "Comment"}
            </SuiButton>
          )}
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
};

export default CommentInput;
